import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import AppRouter from './AppRouter';
import theme from '../theme';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AuthProvider } from '../contexts/AuthContext';
const AppWrapper = () => (_jsx(React.StrictMode, { children: _jsx(ThemeProvider, { theme: theme, children: _jsx(AuthProvider, { children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(AppRouter, {}) }) }) }) }));
export default AppWrapper;
